import React, { useState } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';


const NomineeAddition = () => {
  const [rcno, setRcno] = useState('');
  const [details, setDetails] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [remarksList, setRemarksList] = useState([]); 

  const fetchDetails = async () => {
     if(rcno == null || rcno === "" || rcno === undefined){
		alert("Please Fill RC No");
		return false;	
	}
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/Nominee/getdetails/${rcno}`);
      setDetails(response.data.data);
      setMessage(response.data.message);
      await fetchRemarksList();
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching details');
    } finally {
      setLoading(false);
    }
  };

    const fetchRemarksList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/Nominee/remarks`);
      setRemarksList(Array.isArray(response.data.map(item => item.remark)) ? response.data.map(item => item.remark) : []);
    } catch (err) {
      console.error('Error fetching remarks:', err);
      setRemarksList([]); // fallback to empty array on error
    }
  };

  const approve = async () => {
    if (!remarks) {
      alert('Please select remarks.');
      return;
    }
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const request = {
        fpsId: details.fpsId,
        srcNo: details.rcId,
        remarks,
        noOfMembers: parseInt(details.noOfMembers),
        schemeId: details.schemeId,
      };
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/Nominee/Enable`, request,  
             {   headers: {
            'X-React-Route': window.location.href
          }});
      setMessage(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Error approving');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
<br></br>
        <table align='center' border={1} style={{ width: '35%' }}>
            <tr className='tableheader'>
                <th colSpan={2}>Exceptional Nominee Addition</th>   
            </tr>
            <tr>
             <td>RC No</td>
            <td>
              <input style={{ border: 'black 1px solid' }}
                type="text"
                value={rcno}
                onChange={(e) => setRcno(e.target.value)}
                maxLength={15}
              />
            </td>
            </tr>
            <tr>
             <td  colSpan={2} style={{ textAlign: 'center' }}>
              <button className='button' onClick={fetchDetails} disabled={loading}>
                Submit
              </button>
              <button className='button' onClick={() => window.history.back()}>Back</button>
            </td>
            </tr>
        </table>
        <div align='center'>
      {error && <p style={{ color: 'red'}}>{error}</p>}
      {message && <p style={{ color: 'green' }} className='response'>{message}</p>}
      {loading && <div style={{ textAlign: 'center' }}><CircularProgress /></div>}
</div>
      {details && (
        <div>
          <br></br>
          <table border={1} style={{ margin: 'auto', width: '40%' }}>
            <thead >
              <tr className='tableheader'>
                <th colSpan={2}>RC Information</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>District</td>
                <td>{details.distNameEn}</td>
              </tr>
              <tr>
                <td>Office</td>
                <td>{details.afsoNameEn}</td>
              </tr>
              <tr>
                <td>FPS Id</td>
                <td>{details.fpsId}</td>
              </tr>
              <tr>
                <td>Scheme</td>
                <td>{details.schemeNameEn}</td>
              </tr>
              <tr>
                <td>No Of Members</td>
                <td>{details.noOfMembers}</td>
              </tr>
              <tr>
                <td>RC No</td>
                <td>{details.rcId}</td>
              </tr>
              {details.datetime && (
                <>
                  <tr>
                    <td>Remarks</td>
                    <td>{details.remarks}</td>
                  </tr>
                  <tr>
                    <td>Date Time</td>
                    <td>{details.datetime}</td>
                  </tr>
                </>
              )}
              {!details.datetime && (
                <tr>
                  <td>Remarks</td>
                  <td>
      <select value={remarks} onChange={(e) => setRemarks(e.target.value)}>
        <option value="">Select Remarks</option>
        {remarksList.map((remark, idx) => (
          <option key={idx} value={remark}>{remark}</option>
        ))}
      </select>
    </td>
                </tr>
              )}
              {!details.datetime && (
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center' }}>
                    <button className='button' onClick={approve} disabled={loading}>
                      Approve
                    </button>
                    <button className='button' onClick={() => window.history.back()}>Back</button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default NomineeAddition;